import { API_BASE_URL } from '../config/api.js';
import { authHeaders } from '../lib/auth.js';

export async function checkStaffEmail(email) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/check-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, error: data.error };
}

export async function registerStaff(payload) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, data, error: data.error };
}

export async function loginStaff(email, password) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, data, error: data.error };
}

export async function sendStaffResetOtp(username, mobile) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/send-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, mobile }),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, message: data.message, error: data.error };
}

export async function resetStaffPassword(payload) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, message: data.message, error: data.error };
}

export async function fetchStaffSiteLinks() {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/site-links`, {
    headers: { ...authHeaders() },
    cache: 'no-store',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    return {
      ok: false,
      paymentProofUrl: null,
      stockTrackerUrl: null,
      qrRevision: null,
      error: data.error,
    };
  }
  return {
    ok: true,
    paymentProofUrl:
      typeof data.paymentProofUrl === 'string' && data.paymentProofUrl.trim()
        ? data.paymentProofUrl.trim()
        : null,
    stockTrackerUrl:
      typeof data.stockTrackerUrl === 'string' && data.stockTrackerUrl.trim()
        ? data.stockTrackerUrl.trim()
        : null,
    qrRevision: typeof data.qrRevision === 'string' ? data.qrRevision : null,
  };
}

export async function fetchStaffDuitNowQrBlob(revision) {
  const params = new URLSearchParams();
  if (revision) params.set('v', revision);
  const query = params.toString();
  const res = await fetch(
    `${API_BASE_URL}/api/v1/staff/me/duitnow-qr${query ? `?${query}` : ''}`,
    {
      headers: { ...authHeaders() },
      cache: 'no-store',
    }
  );
  if (!res.ok) return null;
  return res.blob();
}

export async function fetchStaffProfile() {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/me`, {
    headers: { ...authHeaders() },
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, staff: data.staff, error: data.error };
}

export async function fetchStaffPerformance(startISO, endISO) {
  const params = new URLSearchParams({
    startDate: startISO,
    endDate: endISO,
  });
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/me/performance?${params}`, {
    headers: { ...authHeaders() },
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, performance: data.performance ?? null, error: data.error };
}

export async function fetchSurveyData() {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/me/survey-data`, {
    headers: { ...authHeaders() },
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, customers: data.customers ?? [], error: data.error };
}
